

import React from 'react';
import './Footer.css';
import { FaFacebookF, FaInstagram, FaLinkedinIn, FaYoutube, FaTwitter } from 'react-icons/fa';

const Footer = () => {
  return (
    <footer className="footer mybg text-white pt-5">

      <hr className="footer-divider" />

      <div className="middle-footer container-fluid py-4"> {/* container → container-fluid */}
        <div className="row text-white">
        
          {/* Brand */}
          <div className="col-md-3 mb-4 text-start brandcontent"> {/* Added text-start + removed padding start */}
            {/* <img src="/assets/logo.jpg" alt="Lento Logo" className="logo-image" /> */}
            <h5 className="footer-section-title">About US</h5>
            <p className="medium">
              Nasha Mukti Kendra Solan is a trusted Rehab in Solan dedicated to helping individuals overcome addiction and reclaim their lives. 
            </p>
            <div className="social-icons">
              <a href="/" rel="noopener noreferrer"><FaFacebookF /></a>
              <a href="/" rel="noopener noreferrer"><FaInstagram /></a>
              <a href="/" rel="noopener noreferrer"><FaTwitter /></a>
              <a href="/" rel="noopener noreferrer"><FaLinkedinIn /></a>
              <a href="/" rel="noopener noreferrer"><FaYoutube /></a>
              {/* <a href="/" target="_blank" rel="noopener noreferrer"><FaFacebookF /></a>
              <a href="/" target="_blank" rel="noopener noreferrer"><FaInstagram /></a>
              <a href="/" target="_blank" rel="noopener noreferrer"><FaTwitter /></a>
              <a href="/" target="_blank" rel="noopener noreferrer"><FaLinkedinIn /></a>
              <a href="/" target="_blank" rel="noopener noreferrer"><FaYoutube /></a> */}
            </div>
          </div>

          {/* Quick Links */}
          <div className="col-md-3 mb-4">
            <h5 className="footer-section-title">Important Links</h5>
            <ul className="list-unstyled">
              <li>› <a href="/" rel="noreferrer" >Home</a></li>
              <li>› <a href="#about" rel="noreferrer" >About</a></li>
              <li>› <a href="#services" rel="noreferrer" >Treatments</a></li>
              <li>› <a href="#gallery" rel="noreferrer" >Gallery</a></li>
              <li>› <a href="#contact" rel="noreferrer" >Contact US</a></li>
            </ul>
          </div>

          {/* Services */}
          <div className="col-md-3 mb-4">
            <h5 className="footer-section-title">Network Area</h5>
            <ul className="list-unstyled">
              <li>› <a href="/" rel="noreferrer">Haryana</a></li>
              <li>› <a href="/" rel="noreferrer">Chandigarh</a></li>
              <li>› <a href="/" rel="noreferrer">Shimla</a></li>
              <li>› <a href="/" rel="noreferrer">Himachal</a></li>
              <li>› <a href="/" rel="noreferrer">Kashmir</a></li>
              {/* <li>› <a href="/" target="_blank" rel="noreferrer">Haryana</a></li>
              <li>› <a href="/" target="_blank" rel="noreferrer">Chandigarh</a></li>
              <li>› <a href="/" target="_blank" rel="noreferrer">Shimla</a></li>
              <li>› <a href="/" target="_blank" rel="noreferrer">Himachal</a></li>
              <li>› <a href="/" target="_blank" rel="noreferrer">Kashmir</a></li> */}
            </ul>
          </div>

          {/* Contact */}
          <div className="col-md-3 mb-4">
            <h5 className="footer-section-title">Get In Touch</h5>
            <ul className="list-unstyled">
              <li>› <i className="bi bi-telephone-fill me-1"></i><a href="tel:9816791456" target="_blank" rel="noreferrer">9816791456 </a></li>
              <li>› <i className="bi bi-envelope-fill me-1"></i><a href="mailto:nashamuktikendrasolanhp@gmail.com" target="_blank" rel="noreferrer"> nashamuktikendrasolanhp@gmail.com</a></li>
              <li>›
              <i className="bi bi-geo-alt-fill me-1"></i> VILL SIRINAGR TEH, KANDAGHAT 1214, KANDAGHAT 173215
            </li>
              <li>› <a href="#contact" rel="noreferrer">Contact Us</a></li>
            </ul>

            {/* <div className="social-icons">
              <a href="/" target="_blank" rel="noopener noreferrer"><FaFacebookF /></a>
              <a href="/" target="_blank" rel="noopener noreferrer"><FaInstagram /></a>
              <a href="/" target="_blank" rel="noopener noreferrer"><FaTwitter /></a>
              <a href="/" target="_blank" rel="noopener noreferrer"><FaLinkedinIn /></a>
              <a href="/" target="_blank" rel="noopener noreferrer"><FaYoutube /></a>
            </div> */}
          </div>
        </div>

        <hr/>
        <div className="footer-bottom">
          <div className="footer-bottom-content d-flex justify-content-between align-items-center px-4">
            <p><b>Copyright© 2025-26 </b></p>
            <p><b>Nasha Mukti Kendra Solan</b></p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
